import React from "react";
import { Row, Col } from "antd";

import ChangePasswordForm from "../../components/user/changePasswordForm";
import ChangePasswordHeader from "../../components/user/changePasswordHeader";

function UserChangePassWord() {
  return (
    <Row>
      <Col>
        <ChangePasswordHeader />
        <ChangePasswordForm />
      </Col>
    </Row>
  );
}

export default UserChangePassWord;
